/* LANÉA — subtiele, tijdloze motion. Reveal verrijkt een reeds zichtbare default. */
(function () {
  var root = document.documentElement;
  root.classList.add('lanea-js');

  function start() {
    var els = document.querySelectorAll('.lanea [data-reveal]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          // gestaffelde reveal binnen een groep
          var group = el.parentElement ? el.parentElement.querySelectorAll(':scope > [data-reveal]') : [el];
          var idx = Array.prototype.indexOf.call(group, el);
          el.style.setProperty('--reveal-delay', Math.max(0, idx) * 140 + 'ms');
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
